/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeferredIncomeRenameRequestDto
 */
export interface DeferredIncomeRenameRequestDto {
  /**
   *
   * @type {string}
   * @memberof DeferredIncomeRenameRequestDto
   */
  name: string;
}

export function DeferredIncomeRenameRequestDtoFromJSON(json: any): DeferredIncomeRenameRequestDto {
  return DeferredIncomeRenameRequestDtoFromJSONTyped(json, false);
}

export function DeferredIncomeRenameRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DeferredIncomeRenameRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    name: json["name"],
  };
}

export function DeferredIncomeRenameRequestDtoToJSON(value?: DeferredIncomeRenameRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    name: value.name,
  };
}
